export default {
  comesWith: {
    id: 'funnel_cart_page_comes_with',
    defaultMessage: 'Comes with: {accessories}',
  },
}
